import React from 'react';
interface StatCardProps {
  label: string;
  value: string;
  helper?: string;
  emphasis?: boolean;
}
export function StatCard({
  label,
  value,
  helper,
  emphasis = false
}: StatCardProps) {
  return <div className={`rounded-xl border p-5 shadow-card ${emphasis ? 'border-brand-200 bg-brand-50' : 'border-slate-200 bg-white'}`} data-id="element-72" data-mp="ojpbi9dpncs5">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-73" data-mp="jkuqr1w6ne5e">{label}</p>
      <p className={`mt-2 text-2xl font-bold tabular-nums ${emphasis ? 'text-brand-800' : 'text-slate-900'}`} data-id="element-74" data-mp="enunszumqrii">
        {value}
      </p>
      {helper ? <p className="mt-1 text-sm text-slate-500" data-id="element-75" data-mp="5ld0ei38nstx">{helper}</p> : null}
    </div>;
}